import SecondBannerType from './SecondBannerType';

export default SecondBannerType;
